<div class="myDpFooterBar">
  <button type="button" class="myDpHeaderBtn myDpFooterBtn" (click)="onFooterBarTxtClicked()">
    {{ footerBarTxt }}
  </button>
</div>
